import {gsap} from 'gsap'
import type {Vector2} from 'three'

import type {MonaCanvasOpeningAnimation} from './types'

export abstract class OpeningAnimation implements MonaCanvasOpeningAnimation {
  abstract readonly pointerPosition: Vector2
  protected readonly timeline = gsap.timeline({paused: true})
  #elapsedSeconds = 0
  #disposed = false

  get hasReachedEnd() {
    return this.timeline.totalProgress() === 1
  }

  update(deltaSeconds: number) {
    if (this.#disposed || this.hasReachedEnd) return

    // Keep GSAP on the canvas clock, including its visibility and loading pauses.
    this.#elapsedSeconds = Math.min(this.timeline.totalDuration(), this.#elapsedSeconds + deltaSeconds)
    this.timeline.totalTime(this.#elapsedSeconds, false)
    if (this.hasReachedEnd) this.dispose()
  }

  dispose() {
    this.#disposed = true
    this.timeline.kill()
  }
}
